import React from 'react';
import styled from 'styled-components';
import { KeyboardDetectionProvider, cssSpacing, } from '@spotify-internal/encore-web';
import { TWO_COLUMN_MAX_WIDTH, SectionHeader, Grid, ONE_COLUMN_MAX_WIDTH, } from '../../ui';
import { ColorSetWrapper } from '../../ui/Colors/Colors';
import { ContentItemCard } from '../../ui/Components/ContentItemCard/ContentItemCard';
const HeaderGrid = styled(Grid) `
  display: block;
  padding-block-start: ${cssSpacing('looser-3')};
`;
const StyledGrid = styled(Grid) `
  padding-block-start: ${cssSpacing('looser-2')};
  padding-block-end: ${cssSpacing('looser-4')};
  grid-row-gap: ${cssSpacing('looser-3')};
  grid-column-gap: ${cssSpacing('looser')};

  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    padding-block-start: ${cssSpacing('looser')};
    grid-template-columns: 1fr;
    grid-row-gap: ${cssSpacing('looser-4')};
  }

  @media (max-width: ${ONE_COLUMN_MAX_WIDTH}) {
    grid-row-gap: ${cssSpacing('looser-3')};
    padding-block-end: ${cssSpacing('looser-5')};
  }
`;
const TwoUp = styled(StyledGrid) `
  & > * {
    grid-column: span 6;
  }
`;
const ThreeUp = styled(StyledGrid) `
  & > * {
    grid-column: span 4;
  }
`;
const FiveUp = styled(StyledGrid) `
  @media (min-width: calc(${TWO_COLUMN_MAX_WIDTH} + 1px)) {
    & > *:nth-child(1),
    & > *:nth-child(2) {
      grid-column: span 6;
    }

    & > *:nth-child(3),
    & > *:nth-child(4),
    & > *:nth-child(5) {
      grid-column: span 4;
    }
  }
`;
const ItemGrid = ({ children }) => {
    switch (children.length) {
        case 2:
            return React.createElement(TwoUp, null, children);
        case 3:
            return React.createElement(ThreeUp, null, children);
        case 5:
            return React.createElement(FiveUp, null, children);
        default:
            throw new Error("LinkGridModule: 'items' must have 2, 3, or 5 items");
    }
};
export const LinkGridModule = React.forwardRef(({ headline, colors, subtext, items }, ref) => {
    return (React.createElement(KeyboardDetectionProvider, null,
        React.createElement(ColorSetWrapper, { colors: colors },
            React.createElement("div", { ref: ref },
                React.createElement(HeaderGrid, null,
                    React.createElement(SectionHeader, { heading: headline, body: subtext })),
                React.createElement(ItemGrid, null, items === null || items === void 0 ? void 0 : items.map(item => {
                    return (React.createElement(ContentItemCard, { trackCategory: "Link Grid Module", key: item.url, placeholders: false, featured: false, item: {
                            contentType: item.contentType,
                            description: item.description,
                            image: item.image,
                            label: item.label,
                            title: item.title,
                            url: item.url,
                        } }));
                }))))));
});
